export const VERTICALS = ['slots', 'crash', 'betting'] as const;
export type Vertical = (typeof VERTICALS)[number];

export const VERTICAL_LABELS: Record<Vertical, string> = { slots: 'Slots', crash: 'Crash', betting: 'Betting' };

export const VERTICAL_OPTIONS = VERTICALS.map((v) => ({ value: v, label: VERTICAL_LABELS[v] }));

/** Badge colours so a vertical is recognisable at a glance in lists. */
export const VERTICAL_BADGE: Record<Vertical, string> = {
  slots: 'bg-warning-soft text-warning',
  crash: 'bg-danger-soft text-danger',
  betting: 'bg-success-soft text-success',
};

export function verticalLabel(v: string | null | undefined): string {
  return v && v in VERTICAL_LABELS ? VERTICAL_LABELS[v as Vertical] : '';
}
